module.exports = __webpack_public_path__ + "static/media/speaker2.e320d901.jpg";